import React, { useState } from "react";
import RootBulkModal from "./bulkModal";
import Loader from "../../../../components/common/Loader";
import { bulkBillingCycleEdit } from "../../../../features/actions/bulkOperationApi";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Form, Formik } from "formik";
import useDataInputOption from "../../../../hooks/useDataInputOption";
import { FtextField } from "../../../../components/common/FtextField";

const BulkBillingCycleEdit = ({ bulkCustomer, show, setShow }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const inputPermission = {
    billingCycle: true,
  };

  // get data input option from useDataInputOption hook
  const dataInputOption = useDataInputOption(
    inputPermission,
    null,
    "edit",
    null
  );

  //---> Local State
  const [isLoading, setIsLoading] = useState();

  const billingCycleHandler = ({ billingCycle }) => {
    const data = {
      customerIds: bulkCustomer.map((item) => item.original.id),
      billingCycle: billingCycle.toISOString(),
    };

    bulkBillingCycleEdit(dispatch, data, setIsLoading, setShow);
  };

  return (
    <RootBulkModal
      show={show}
      setShow={setShow}
      header={t("updateBillingCycle")}
    >
      <Formik
        initialValues={{
          ...dataInputOption.inputInitialValues,
        }}
        validationSchema={dataInputOption?.validationSchema}
        onSubmit={(values) => billingCycleHandler(values)}
        enableReinitialize
      >
        {() => (
          <Form>
            <div className="displayGrid">
              {dataInputOption?.inputOption.map(
                (item) => item?.isVisible && <FtextField {...item} />
              )}
            </div>

            <div className="displayGrid1 float-end mt-3">
              <button
                type="button"
                className="btn btn-secondary border-0"
                disabled={isLoading}
                onClick={() => setShow(false)}
              >
                {t("cancel")}
              </button>

              <button
                type="submit"
                className="btn btn-success border-0"
                disabled={isLoading}
              >
                {isLoading ? <Loader /> : t("submit")}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </RootBulkModal>
  );
};
export default BulkBillingCycleEdit;
